snt-source-link {
    display: inline-block;

    a {
        height: 25px;
        font-size: 14px;
        color: $color-primary-grey;
        display: flex;
        align-items: center;
        border: 1px solid $color-primary-grey;
        border-radius: 22px;
        padding: 10px;
        position: relative;
        text-decoration: none;

        .icon-new-window:after {
            content: "\e960";
            font-size: 1.02em!important;
            padding-left: 5px;
            color: $color-primary-grey;
            display: inline-block;
            position: relative;
        }

        .icon-new-window:before {
            content: "";
        }
    }

    a:hover {
        color: $color-primary-accent;
        border-color: $color-primary-accent;
        box-shadow: 0 0 0 2px $color-primary-accent;

        .icon-new-window:after {
            color: $color-primary-accent;
        }
    }

    a:focus {
        outline: none;
    }

    a:focus:after {
        content: '';
        display: block;
        position: absolute;
        top: -7px;
        bottom: -7px;
        left: -7px;
        right: -7px;
        border-radius: 30px;
        border: 1px solid $color-primary-grey;
    }

    .link-content {
        max-width: 249px;
        display: inline-block;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .full-content {
        max-width: 265px;
        display: inline-block;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
}